import { render, staticRenderFns } from "./ThematicManagementList.vue?vue&type=template&id=c74db1ca&scoped=true&"
import script from "./ThematicManagementList.vue?vue&type=script&lang=js&"
export * from "./ThematicManagementList.vue?vue&type=script&lang=js&"
import style0 from "./ThematicManagementList.vue?vue&type=style&index=0&id=c74db1ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c74db1ca",
  null
  
)

export default component.exports